import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import moment from "moment";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../global";
import Tooltip from "@mui/material/Tooltip";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { getUsers } from "../../utils/databaseHelper";
import { Autocomplete, TextField } from "@mui/material";
import ListWrap from "../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";

const columns = [
  { id: "id", label: "Sr. No." },
  { id: "companyName", label: "Client ", minWidth: 40 },
  { id: "address", label: "Address ", minWidth: 40 },
  // {
  //   id: "outwardDate",
  //   label: "outward date ",
  //   align: "left",
  //   minWidth: 40,
  // },
  // {
  //   id: "siteInwardDate",
  //   label: "Site Inward Date",
  //   minWidth: 40,
  //   align: "left",
  //   format: (value) => value.toFixed(2),
  // },
  // {
  //   id: "expectedReturnDate",
  //   label: "expected return date",
  //   minWidth: 40,
  //   align: "left",
  //   format: (value) => value.toFixed(2),
  // },
  // {
  //   id: "actualReturnDate",
  //   label: "Actual Return date ",
  //   minWidth: 40,
  //   align: "left",
  //   format: (value) => value.toFixed(2),
  // },
];

function createData(id, companyName, address, outwardDate, expectedReturnDate, actualReturnDate) {
  return { id, companyName, address, outwardDate, expectedReturnDate, actualReturnDate };
}

export default function StandardsInOutList() {
  const [page, setPage] = React.useState(0);
  const urlPath = useLocation();
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);

  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [standardList, setStandardList] = React.useState([]);
  const [stInOutData, setStInOutData] = React.useState([]);
  const [engineers, setEngineers] = React.useState([]);
  const editAccess = localStorage.getItem("editAccess")?.split(",").map(Number);
  const [totalRows, setTotalRows] = React.useState(0);
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") ? true : false);
  const userType = localStorage.getItem("type");
  const _clientId = localStorage.getItem("clientId");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const submitSiteDelete = (id) => {
    let url = BASE_URL;
    let query = {
      query: `UPDATE standardInOut SET status = -1 WHERE clientId = ${id}`,
    };
    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
        toast("Deleted standard In/Out!");
        window.location.reload();
      })
      .catch((error) => console.log(error));
  };

  const getEngineers = () => {
    getUsers(2, (res) => {
      return res.data.map((e) => {
        return { ...e, label: e.userName };
      });
    })
      .then((engineers) => {
        setEngineers(engineers);
      })
      .catch((error) => console.log(error));
  };

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        Client: "cl.companyName",
        "Expected Return Date": "si.expectedReturnDate",
        "Actual Return Date": "si.actualReturnDate",
        "Outward Date": "si.outwardDate",
      }[searchBy];
      if (colName.includes("Date")) {
        whereConditions = `where ${colName} between '${moment(from).format(
          "YYYY-MM-DD"
        )}' and '${moment(to).format("YYYY-MM-DD")}'`;
      } else {
        whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
      }
    }

    // PAGINATION
    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${rowsPerPage * Number(page)}`;
    }

    if (whereConditions === "") {
      whereConditions = " where ";
    } else {
      whereConditions += " and ";
    }

    whereConditions += " si.status = 1 ";

    // USER TYPE FILTER
    if (userType == "3") {
      whereConditions += ` and si.clientId = ${_clientId} `;
    }

    let data = {
      query: `SELECT si.clientId, cl.companyName, si.standardId, si.purpose, si.outwardDate, si.expectedReturnDate,si.userId, si.remark, si.id AS standardInOutId, a.address AS address FROM (SELECT clientId, MIN(id) AS min_id FROM standardInOut WHERE status = 1 GROUP BY clientId) AS unique_clients JOIN standardInOut AS si ON unique_clients.min_id = si.id LEFT JOIN clients AS cl ON si.clientId = cl.id LEFT JOIN addresses AS a ON a.id = SUBSTRING_INDEX(SUBSTRING_INDEX(si.address, ',', 1), ',', -1) ${whereConditions} order by si.id DESC ${pagination_settings}`,
    };

    // COUNT QUERY
    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM (SELECT si.clientId FROM (SELECT clientId, MIN(id) AS min_id FROM standardInOut WHERE status = 1 GROUP BY clientId) AS unique_clients JOIN standardInOut AS si ON unique_clients.min_id = si.id LEFT JOIN clients AS cl ON si.clientId = cl.id LEFT JOIN addresses AS a ON a.id = SUBSTRING_INDEX(SUBSTRING_INDEX(si.address, ',', 1), ',', -1) ${whereConditions} GROUP BY si.clientId) AS tmp`;    

    return data;
  };

  function getTotalRows() {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0].no_of_rows);
      })
      .catch((err) => console.log("data fetching error: ", err));
  }

  function getStandardInOutList() {
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setStandardList(res.data);
      })
      .catch((err) => console.log("data fetching error: ", err));
  }

  const initializeStInOutData = () => {
    var rowDaata = [];
    for (let i = 0; i < standardList.length; i++) {
      rowDaata.push(
        createData(
          standardList[i].clientId,
          standardList[i].companyName,
          standardList[i].address,
          standardList[i].outwardDate
            ? moment(standardList[i].outwardDate).format("DD-MM-YYYY")
            : "",
          standardList[i].expectedReturnDate
            ? moment(standardList[i].expectedReturnDate).format("DD-MM-YYYY")
            : "",
          standardList[i].actualReturnDate
            ? moment(standardList[i].actualReturnDate).format("DD-MM-YYYY")
            : ""
        )
      );
    }
    setStInOutData(rowDaata);
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if(storedSearchBy){
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    setSearched(true);
    getStandardInOutList();
    getTotalRows();
  };

  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    setSearchBy("Client");
    setSearchKey("");
    setFrom(null);
    setTo(null);
    setSearched(false);
  };

  useEffect(() => {
    if(searched==false){
      getStandardInOutList();
      getTotalRows();
    }
    if (searched) {
      setPage(0);
    }
  }, [searched]);

  useEffect(() => {
    getStandardInOutList();
    getTotalRows();
    getEngineers();
  }, [rowsPerPage, page]);

  useEffect(() => {
    initializeStInOutData();
  }, [standardList]);

  return (
    <ListWrap>
      {userType != 3 && (
        <>
        <Toolbar style={{ padding: "0px" }}>
          <Button
            variant="contained"
            size="small"
            component={Link}
            to="/masterEQPInOutList/createStandardInOut/0"
          >
            <b>ADD master In/Out</b>
          </Button>
        </Toolbar>
        <div
          className="mb-2"
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
            }}
            className="Listinputcss"
            size="small"
            id="combo-box-demo"
            value={searchBy}
            options={[
              { key: "cl.companyName", label: "Client" },
              // { key: "si.expectedReturnDate", label: "Expected Return Date" },
              // { key: "si.actualReturnDate", label: "Actual Return Date" },
              // { key: "si.outwardDate", label: "Outward Date" },
            ]}
            renderInput={(params) => (
              <TextField {...params} label="Search By" />
            )}
            onInputChange={(event, newInputValue) => {
              setSearchBy(newInputValue);
              setSearched(false);
            }}
          />

          <TextField
            id="outlined-basic"
            inputProps={{
              autoComplete: 'off',
            }}
            label={"enter " + searchBy}
            size="small"
            className="Listinputcss"
            variant="outlined"
            value={searchKey}
            onChange={(e) => {
              setSearchKey(e.target.value);
              setSearched(false)
            }}
            sx={{ marginLeft: "10px" }}
          />
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            color={searched ? "error" : "primary"}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              searched ? clearSearch() : search();
            }}
          >
            {searched ? <RestartAltIcon /> : <SearchIcon />}
          </Button>
        </div>
        </>
      )}
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small" sx={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id} style={{ minWidth: col.minWidth }}>
                  <b>{col.label}</b>
                </TableCell>
              ))}
              <TableCell>
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stInOutData.length > 0 ? (
              stInOutData.map((row, index) => (
                <TableRow hover key={index}>
                    {columns.map((column) => {
                      let value = row[column.id];
                      if (column.id === "id") value = page * rowsPerPage + index + 1;
                      return <TableCell key={column.id}>{value}</TableCell>;
                  })}
                    <TableCell>
                      <ButtonGroup size="small" aria-label="small button group">
                        <Tooltip
                          title="Edit standard In/Out"
                          placement="top-start"
                        >
                          <Button
                            component={Link}
                            to={`/masterEQPInOutList/editStandardInOut/${row.id}`}
                          >
                            <PreviewIcon />
                          </Button>
                        </Tooltip>
                        {userType != 3 && (
                        <Tooltip title="Delete standard In/Out">
                          <Button
                            onClick={() => {
                              if (window.confirm("Really want to delete standard?")) {
                                submitSiteDelete(row.id);
                              }
                            }}
                            disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                          >
                            <DeleteIcon style={{ color:!(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545' }} />
                          </Button>
                        </Tooltip>
                        )}
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                 <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={paginationrowsPerPageOptions}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <ToastContainer />
      </TableContainer>
    </ListWrap>
  );
}
